export enum RiskCalculateType {
  QUERY = 'query',
  USERS = 'users',
  FILES = 'files',
  IDENTITY = 'identity',
  ALGORITHM = 'algorithm',
  ACTIVITIES = 'activities',
  THIRD_PARTY = 'third_party',
  APPLICATION = 'application',
  FILES_MESSAGES = 'files_messages',
  SHADOW_SAAS_USERS = 'shadow_saas_users',
  THIRD_PARTY_APPLICATIONS_USERS = 'third_party_applications_users',
}
